import React, { useState } from "react";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import { alpha } from "@mui/material";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: (typeof theme.spacing === 'function' ? theme.spacing(2) : theme.spacing * 2 + 'px'),
  marginLeft: 0,
  marginBottom: "24px",
  width: "100%",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: (typeof theme.spacing === 'function' ? theme.spacing(0, 2) : '0px 16px'),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: (typeof theme.spacing === 'function' ? theme.spacing(1, 1, 1, 0) : '8px 8px 8px 0px'),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${(typeof theme.spacing === 'function' ? theme.spacing(4) : theme.spacing * 4 + 'px')})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
    borderBottom: "1px solid var(--night400)",
  },
}));

export default function SearchField(props) {
  const [searchValue, setSearchValue] = useState("");

  return (
    <Search>
      <SearchIconWrapper>
        <SearchIcon />
      </SearchIconWrapper>
      <StyledInputBase
        placeholder="Search…"
        inputProps={{ "aria-label": "search" }}
        value={searchValue}
        onChange={(event) => {
          setSearchValue(event.target.value);
        }}
        onKeyDownCapture={(event) => {
          if (event.key === "Enter") {
            props.searchClickAction(searchValue);
          }
        }}
        variant="standard"
      />
    </Search>
  );
}
